import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const DEFAULT = {
    title: 'ISO 27001 Uyumluluğunda Yeni Nesil Güç',
    title_en: 'Next-Generation Power in ISO 27001 Compliance',
    description: 'Bilgi Güvenliği Yönetim Sisteminizi (BGYS) modernize edin. 93 kontrol maddesi, risk yönetimi ve varlık envanterini tek bir merkezden yönetin.',
    description_en: 'Modernize your Information Security Management System (ISMS). Manage 93 control requirements, risk processes, and asset inventories from a single centralized platform.',
    primaryButtonText: 'Hemen Başla',
    primaryButtonText_en: 'Start Now',
    secondaryButtonText: null,
    secondaryButtonText_en: null,
};

const Banner = ({ data }) => {
    const navigate = useNavigate();
    const { i18n } = useTranslation();

    const lang = i18n.language === 'en' ? 'en' : 'tr';
    const tx = (tr, en) => (lang === 'en' ? (en || tr) : tr);

    const d = { ...DEFAULT, ...data };

    const title = tx(d.Title || d.title, d.Title_en || d.title_en);
    const description = tx(d.Description || d.description, d.Description_en || d.description_en);
    const primaryText = tx(d.primaryButtonText, d.primaryButtonText_en);
    const secondaryText = tx(d.secondaryButtonText, d.secondaryButtonText_en);

    return (
        <section
            className="flex flex-col items-center justify-center text-center w-full min-h-[250px] sm:min-h-[300px] px-4 sm:px-6 py-10 sm:py-16"
            style={{ background: 'linear-gradient(180deg, #114B3D 0%, #68B09F 100%)' }}
        >
            <h1 className="text-white text-xl sm:text-2xl md:text-4xl lg:text-5xl uppercase mb-3 sm:mb-4 leading-tight px-2">{title}</h1>
            <p className="text-white max-w-[520px] opacity-90 mb-6 sm:mb-8 text-sm sm:text-base px-4">{description}</p>
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 w-full sm:w-auto px-4 sm:px-0">
                {primaryText && (
                    <button
                        onClick={() => navigate('/iletisim')}
                        className="px-6 sm:px-8 py-3 sm:py-3.5 font-bold rounded-xl bg-white text-[#114B3D] border-none cursor-pointer hover:scale-105 transition-transform text-sm sm:text-base"
                    >
                        {primaryText}
                    </button>
                )}
                {secondaryText && (
                    <button
                        onClick={() => navigate('/demo')}
                        className="px-6 sm:px-8 py-3 sm:py-3.5 font-bold rounded-xl bg-transparent text-white border border-white/50 cursor-pointer hover:scale-105 transition-transform text-sm sm:text-base"
                    >
                        {secondaryText}
                    </button>
                )}
            </div>
        </section>
    );
};

export default Banner;